export default __webpack_public_path__ + "static/media/17.ce668c5d.jpg";